<template>
  <div class="app">
    <video controls="controls" muted ref="audios">
      <source src="http://fe-beta1.91taogu.com/other/tool/mp3/dingdong.mp4" type="audio/mpeg" />
    </video>
    <Modal
        v-model="modal1"
        @on-ok="funcBtn"
        @on-cancel="cancel">
        <p>是否会播放提示音</p>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { api } from '@/services'
export default {
  // name: 'checkMessage',
  data () {
    return {
      modal1: false,
      timer: false,
      videoMuted: false
    }
  },
  computed: {
    ...mapGetters({
      power: 'power/power'
    })
  },
  created () {
    var that = this
    this.$nextTick(function () {
      // 待审核消息提醒的权限
      if (this.power.length <= 0) {
        return false
      }
      if (this.power.indexOf('92') <= 0) {
        return false
      }
      that.modal1 = true
    })
  },
  methods: {
    cancel () {
      this.$refs.audios.muted = true
      this.videoMuted = false
      this.intervalSync()
    },
    funcBtn () {
      this.$refs.audios.muted = false
      this.videoMuted = true
      this.intervalSync()
    },
    // 药师管理-医院
    intervalSync () {
      let that = this
      this.getMessage()
      setTimeout(() => {
        that.intervalSync()
      }, 1000 * 20)
    },
    // 轮询消息提示
    getMessage () {
      let that = this
      api.getMessageInfoList({data: {params: {}}}).then(res => {
        if (res.code === 0 && res.data && res.data.total > 0) {
          let i
          for (i = 0; i < res.data.total; i++) {
            if (that.videoMuted) {
              that.$refs.audios.play()
              that.$refs.audios.muted = false
            }
            that.$Notice.open({
              title: '调方提醒',
              desc: res.data.list[i].message,
              duration: 0
            })
          }
        } else {
          clearTimeout(that.timer)
          this.$Notice.destroy()
        }
      })
    }
  }
}
</script>

<style>

.ivu-notice-custom-content{
   position: static;
}
/* audio, video {
    display: inline-block;
    position: fixed;
    z-index: 1;
    top: 0;
}
.btn{
  position: fixed;
  right: 300px;
  z-index: 999;
  top: 0;
} */

</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/messageInfo/checkMessage.vue